import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
 
const SprintTrendChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <div style={{ color: '#64748b', textAlign: 'center' }}>No sprint data available to plot trends.</div>;
  }

  // Custom styling for the tooltip to match your dark theme
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          backgroundColor: '#132838',
          border: '1px solid rgba(159, 223, 255, 0.18)',
          padding: '12px',
          borderRadius: '8px',
          color: '#e2e8f0',
          boxShadow: '0 10px 24px rgba(0,0,0,0.4)'
        }}>
          <h4 style={{ margin: '0 0 8px 0', color: '#fff' }}>{label}</h4>
          {payload.map((entry, index) => (
            <div key={index} style={{ color: entry.color, fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '4px' }}>
              {entry.name}: {entry.value}
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{ width: '100%', height: '350px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
          {/* Faint grid lines */}
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(149, 207, 229, 0.1)" vertical={false} />
          
          {/* X and Y axes */}
          <XAxis dataKey="name" stroke="#9db4c7" tick={{ fill: '#9db4c7', fontSize: 12 }} />
          <YAxis stroke="#9db4c7" tick={{ fill: '#9db4c7', fontSize: 12 }} />
          
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ paddingTop: '20px' }} />

          {/* The Data Lines */}
          {/* <Line 
            type="monotone" 
            dataKey="assigned" 
            name="Total Assigned Items" 
            stroke="#94a3b8" // Slate gray
            strokeWidth={3}
            dot={{ r: 4, fill: '#121926' }}
            activeDot={{ r: 6 }} 
          /> */}
          {/* <Line 
            type="monotone" 
            dataKey="completed" 
            name="Completed Items" 
            stroke="#38bdf8" // Cyan / Teal
            strokeWidth={3}
            dot={{ r: 4, fill: '#121926' }}
            activeDot={{ r: 6 }} 
          /> */}
          <Line 
            type="monotone" 
            dataKey="velocity" 
            name="Developer Velocity" 
            stroke="#f1c98a" // Gold / Orange
            strokeWidth={3}
            dot={{ r: 4, fill: '#121926' }}
            activeDot={{ r: 6 }} 
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SprintTrendChart;
